import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { patientVitalsData } from '../mockData/patient-vitals-data';

const PatientExtractApi = [
  rest.get(`${API_ROOT}patient-vitals/undefined?patientId=patient_id2&height=true`, (req, res, ctx) => res(ctx.json(patientVitalsData))),
];

export default PatientExtractApi;
